// src/services/mealService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  MEAL_LIST,
  MEAL_ADD,
  MEAL_UPDATE,
  MEAL_DELETE,
  REVIEW_LIST,
  REVIEW_DETAIL,
  STAFF_ADD,
  REVIEW_EXPORT
} from "../../config/constants"; // Adjust endpoints as per your config

const reviewService = createApi({
  reducerPath: "reviewService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Review"],
  endpoints: (builder) => ({
    getReviews: builder.query({
      query: (bodyData) => ({
        url: REVIEW_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Review"],
    }),
    getReviewDetails: builder.query({
      query: (id) => ({
        url: `${REVIEW_DETAIL}/${id}`, // Endpoint to fetch user details
        method: "GET",
      }),
    }),
    addMeal: builder.mutation({
      query: (mealData) => ({
        url: MEAL_ADD, // Endpoint to add a meal
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Review"],
    }),

    addStaff: builder.mutation({
      query: (mealData) => ({
        url: STAFF_ADD, // Endpoint to add a staff
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Review"],
    }),

    updateMeal: builder.mutation({
      query: ({ mealId, updatedData }) => ({
        url: `${MEAL_UPDATE}/${mealId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["Review"],
    }),
    getReviewExportFile: builder.mutation({
      query: (bodyData) => ({
        url: REVIEW_EXPORT, // Endpoint to fetch ingredient list
        method: "POST",
        data: bodyData,
      }),
    }),
    deleteMeal: builder.mutation({
      query: (mealId) => ({
        url: `${MEAL_DELETE}/${mealId}`, // Endpoint to delete a meal
        method: "DELETE",
      }),
      invalidatesTags: ["Review"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetReviewExportFileMutation,
  useGetReviewsQuery,
  useGetReviewDetailsQuery,
  useAddMealMutation,
  useAddStaffMutation,
  useUpdateMealMutation,
  useDeleteMealMutation,
} = reviewService;

// Export the reducer to be included in the store
export default reviewService;
